import { render, staticRenderFns } from "./ShopReviews.vue?vue&type=template&id=0615d776&"
import script from "./ShopReviews.vue?vue&type=script&lang=js&"
export * from "./ShopReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports